var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-img',{attrs:{"src":_vm.value,"contain":_vm.contain,"height":_vm.height,"width":_vm.width,"max-height":_vm.maxHeight,"max-width":_vm.maxWidth,"lazy-src":_vm.lazySrc},on:{"click":_vm.click}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }